import { colors } from '../colors';

export const header = {
  backgroundColor: colors.blue[800],
};
